<script setup>
import MainComp from '../components/MainPage.vue'
//import profileList from '../components/profileData.js'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, onUnmounted } from 'vue'

const route = useRoute()
const router = useRouter()
var pageId = Number(route.params.id)
var isBefore = false

onMounted(() => {
  pageId = Number(route.params.id)
  window.addEventListener("touchstart",startevent);
  window.addEventListener("touchend", endevent);
})

onUnmounted(() => {
  window.removeEventListener("touchstart",startevent);
  window.removeEventListener("touchend", endevent);
})

/*const profileData = {
  pageIdStr: String(route.params.id),
  number: profileList[pageId-1].number,
  artistName: profileList[pageId-1].artistName,
  mainDetail: profileList[pageId-1].mainDetail,
  content1:profileList[pageId-1].content1,
  content2: profileList[pageId-1].content2,
  instagramId: profileList[pageId-1].instagramId,
}*/

router.beforeEach(function(to, from, next){
  if(route.path.split('/')[1] == 'main'){
    from.meta.transition = 'slide'
    if(isBefore || to.path == '/boxes') {
      to.meta.transition = 'slide-left'
    }
    else {
      to.meta.transition = 'slide'
    }
  }
  next();
});

function startevent(event) {
  if(event.touches.length === 1){
    start = event.touches.item(0).clientX;
  }else{
    start = null;
  }
}

function endevent(event) {
  var offset = 100;
  if(start){
    var end = event.changedTouches.item(0).clientX;
    if(end > start + offset){
      isBefore = true
      if(pageId == 1 ){
        router.push('/boxes')
      }
      else {
        pageId--
        router.push('/main/'+String(pageId).padStart(2,"0"));
      }
    }
    else if(end < start - offset ){
      isBefore = false
      if(pageId == 27){
        router.push('/contact1')
      }
      else {
        pageId++
        router.push('/main/'+String(pageId).padStart(2,"0"));
      }
    }
  }
}
var start = null;
</script>

<template>
  <div class="MainPages" :key="pageId">
    <component :is="MainComp"/>
  </div>
</template>

<style scoped>
.MainPages {
  background-color: #0D00B4;
  z-index: -3;
}
</style>